import React from 'react';
import { Box, makeStyles } from '@material-ui/core';

interface AvatarPopupFieldProps {
    label: string;
    value: string | undefined;
    icon?: React.ReactNode;
    labelStyle?: React.CSSProperties;
    valueStyle?: React.CSSProperties;
}

const useStyles = makeStyles({
    label: {
        fontWeight: 600,
        color: '#555',
        marginBottom: '2px',
        fontSize: '12px',
        letterSpacing: '0.5px',
    },
    valueContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    value: {
        color: '#333',
    },
});

export const AvatarPopupField: React.FC<AvatarPopupFieldProps> = ({
    label,
    value,
    icon,
    labelStyle,
    valueStyle,
}) => {
    const classes = useStyles();

    return (
        <Box>
            <Box className={classes.label} style={labelStyle}>
                {label}
            </Box>
            <Box className={classes.valueContainer}>
                <Box className={classes.value} style={valueStyle}>
                    {value || '—'}
                </Box>
                {icon}
            </Box>
        </Box>
    );
};
